import Promise from 'promise-polyfill'
import ReactDOM from 'react-dom'
import React from 'react'
import WebFontLoader from 'webfontloader'

import { Root } from 'containers'
import configureStore from 'redux/store'

import './index.css'

if (!window.Promise) {
  window.Promise = Promise
}

WebFontLoader.load({
  google: {
    families: [
      'Josefin Sans:300,400,600,700',
      'Roboto:300,400,500,700',
      'Material Icons'
    ]
  }
})

const store = configureStore()

ReactDOM.render(<Root store={store} />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js